import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RemoteController from './components/RemoteController';
import RemoteCode from './components/RemoteCode';
import ResetPassword from './components/ResetPassword';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<RemoteController />} />
          <Route path="/remote" element={<RemoteCode />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;